export default {
  BASE_URL: 'psm/tap/admin',
  api: [
    {
      name: 'listForSubmitted',
      desc: '获取待审核列表',
      method: 'GET',
      path: '/listForSubmitted'
    },

    {
      name: 'listForAudited',
      desc: '获取已审核列表',
      method: 'GET',
      path: '/listForAudited'
    },
    {
      name: 'listForApproved',
      desc: '获取已评审列表',
      method: 'GET',
      path: '/listForApproved'
    },
    {
      name: 'listForReject',
      desc: '获取驳回列表',
      method: 'GET',
      path: '/listForReject'
    },{
      name: 'listForWaitCer',
      desc: '获取待发证列表',
      method: 'GET',
      path: '/listForWaitCer'
    },
    {
      name: 'export',
      desc: '导出',
      method: 'POST',
      path: '/export'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'GET',
      path: '/remove'
    },
    {
      name: 'audit',
      desc: '审批',
      method: 'POST',
      path: '/audit'
    },
    {
      name: 'history',
      desc: '历史申报',
      method: 'GET',
      path: '/history'
    }
    ,{
      name: 'wait-cer',
     desc: '设置待发证',
     method: 'POST',
     path: '/auditForWaitCer'     
   },{
      name: 'auditForExit',
     desc: '退出确认',
     method: 'POST',
     path: '/auditForExit'     
   },
   {
     name:'declare-update',
     desc: '更新申报信息',
     method: 'POST',
     path: '/update'
   },{
     name:'download-zip',
     desc:'压缩下载所有文件',
     method:'GET',
     path:'/packageDownload'
   },{
     name:'firstPass',
     desc:'符合性审查通过批量提交',
     method:'POST',
     path:'/firstPass'
   },{
    name:'firstNoPass',
    desc:'符合性审查我未通过批量提交',
    method:'POST',
    path:'/firstNoPass'
   }
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/tap/admin.js